import { ChevronIcon } from '@insta-club/components';
import { cn } from '@insta-club/utilities';
import type { ClassValue } from 'clsx';
import { useState } from 'react';

type AccordionItemData = {
    title: React.ReactNode | string;
    children: React.ReactNode;
    chevronTitle?: string;
    chevronClassName?: string;
    extera?: React.ReactElement;
    open?: boolean;
};

type AccordionProps = {
    items?: AccordionItemData[];
    className?: ClassValue;
    itemClassName?: ClassValue;
};

const Accordion = ({ items = [], className, itemClassName }: AccordionProps) => {
    return (
        <div className={'space-y-3'}>
            {items.map((item, index) => {
                return (
                    <AccordionItem
                        key={index}
                        open={item.open}
                        title={item.title}
                        extera={item.extera}
                        className={className}
                        itemClassName={itemClassName}
                        chevronTitle={item.chevronTitle}
                        chevronClassName={item.chevronClassName}
                    >
                        {item.children}
                    </AccordionItem>
                );
            })}
        </div>
    );
};

const AccordionItem = ({
    title,
    extera,
    children,
    className,
    chevronTitle,
    open = false,
    itemClassName,
    chevronClassName
}: {
    open?: boolean;
    className?: ClassValue;
    chevronTitle?: string;
    children: React.ReactNode;
    chevronClassName?: string;
    itemClassName?: ClassValue;
    extera?: React.ReactElement;
    title: React.ReactNode | string;
}) => {
    const [isOpen, setIsOpen] = useState(open);

    return (
        <div
            className={cn(
                'rounded-xl border-2 border-gray-300',
                {
                    'border-primary-500 bg-gray-50': isOpen
                },
                className
            )}
        >
            <button
                onClick={() => setIsOpen(!isOpen)}
                className='flex w-full justify-between p-4 text-left text-sm font-semibold focus:outline-none'
            >
                <div className='flex-1'>{title}</div>
                <div className={cn('flex cursor-pointer items-center gap-2', chevronClassName)}>
                    {chevronTitle ? <span>{chevronTitle}</span> : null}
                    <ChevronIcon className={cn(isOpen ? 'rotate-90' : '', 'transition-transform')} />
                </div>
            </button>
            <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? '' : 'max-h-0'}`}>
                <div className={cn('p-4 text-sm font-medium text-gray-500', itemClassName)}>{children}</div>
            </div>
            {extera ? <div className='px-4 pb-4'>{extera}</div> : null}
        </div>
    );
};

export default Accordion;

